<template>
  <div>
    <form @submit.prevent="submit">
      <fields
        :fields="fields.except('category_id', 'locations', 'key_word', 'image_banner', 'alt_text_banner_image', 'show_search_input')"
        :model="model"
        :errors="errors"
        layout="vertical"/>

      <fields
        v-if="model.use_banner"
        :fields="fields.only('image_banner', 'alt_text_banner_image', 'show_search_input')"
        :model="model"
        :errors="errors"
        layout="vertical"/>

      <fields
        :fields="fields.only('locations', 'key_word')"
        :model="model"
        :errors="errors"
        layout="vertical"/>

      <div class="form-group">
        <label>Category</label>
        <tree-select 
          v-model="model.category_id" 
          :options="options"/>
      </div>

      <div class="form-group">
        <b-button 
          type="button" 
          variant="primary mr-2" 
          @click="generate">Save and generate</b-button>
        <b-button 
          type="submit" 
          variant="primary mr-2">Save</b-button>
        <b-button 
          type="button" 
          variant="light" 
          @click="cancel">Cancel</b-button>
      </div>
    </form>
  </div>
</template>

<script>
import ResourceFormMixin from '../mixins/ResourceFormMixin';
import TreeMixin from '../mixins/TreeMixin'
import Proxy from './Proxy';

export default {
  name: 'PagesForm',

  mixins: [ResourceFormMixin, TreeMixin],

  created() {
    this.loadForm(Proxy);
  },

  methods: {
    submit() {
      this.save(Proxy).then(() => {
        this.$toast.success('Template was saved successfully');
      });
    },

    generate() {
      let promise;

      this.save(Proxy).then(result => {
        if (result.data.id) {
          promise = new Proxy()
            .generatePages(result.data.id);

          promise
            .then(() => {
              this.$toast.success('Template was saved and generating pages start');
            })
            .catch((response) => {
              this.onSaveError(response);
              return Promise.reject(response);
            });
        }
      });
    }

  },
};
</script>

